import { Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import { DeviceWithMapInfo } from 'src/models';

import samsaraLogo from '../assets/icons/samsara-logo.png';
import skybitzLogo from '../assets/icons/skybitz-logo.jpeg';
import premierLogo from '../assets/icons/premier-logo.png';
import anytrekLogo from '../assets/icons/anytrek-logo.png';

interface AssetPreviewProps {
  device: DeviceWithMapInfo;
}

export default function AssetPreview({ device }: AssetPreviewProps) {
  const getAssetDisplay = () => {
    const externalId = device.externalIdentifier || "";
    const deviceType = device.deviceType || "";

    // eld truck
    if (deviceType.startsWith("ELD Truck")) {
      return {
        type: 'icon' as const,
        icon: 'ph:truck',
        backgroundColor: '#e0e0e0'
      };
    }

    // ct trailer
    if (externalId.startsWith("1|")) {
      return {
        type: 'icon' as const,
        icon: 'fa-solid:trailer',
        backgroundColor: '#e0e0e0'
      };
    }

    // samsara
    if (externalId.startsWith("2|")) {
      return {
        type: 'image' as const,
        src: samsaraLogo,
        alt: 'Samsara',
        backgroundColor: '#e0e0e0',
        imageStyle: { width: 40, height: 40, objectFit: 'contain' as const }
      };
    }
    
    // skybitz
    if (externalId.startsWith("3|")) {
      return {
        type: 'image' as const,
        src: skybitzLogo,
        alt: 'SkyBitz',
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        imageStyle: { width: 40, height: 40, objectFit: 'contain' as const }
      };
    }
    
    // premier
    if (externalId.startsWith("4|")) {
      return {
        type: 'image' as const,
        src: premierLogo,
        alt: 'Premier',
        backgroundColor: '#e0e0e0',
        border: '1px solid #e0e0e0',
        imageStyle: { width: 58, height: 58, objectFit: 'contain' as const, borderRadius: '50%' }
      };
    }

    // ct immobilizer
    if (externalId.startsWith("5|")) {
      return {
        type: 'icon' as const,
        icon: 'carbon:vpn-connection',
        backgroundColor: '#e0e0e0'
      };
    }
    
    // anytrek
    if (externalId.startsWith("6|")) {
      return {
        type: 'image' as const,
        src: anytrekLogo,
        alt: 'Anytrek',
        backgroundColor: '#e0e0e0',
        imageStyle: { width: 48, height: 48, objectFit: 'contain' as const, borderRadius: '50%' }
      };
    }
    
    return {
      type: 'icon' as const,
      icon: 'ph:truck',
      backgroundColor: '#e0e0e0'
    };
  };

  const assetConfig = getAssetDisplay();

  return (
    <Box
      sx={{
        width: 60,
        height: 60,
        borderRadius: "50%",
        backgroundColor: assetConfig.backgroundColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto 12px",
        fontSize: "24px",
        fontWeight: "bold",
        color: "#666",
        ...(assetConfig.border && { border: `${assetConfig.border}` }),
      }}
    >
      {assetConfig.type === 'image' ? (
        <img 
          src={assetConfig.src} 
          alt={assetConfig.alt}
          style={assetConfig.imageStyle} 
        />
      ) : (
        <Iconify 
          icon={assetConfig.icon} 
          width={32} 
          height={32}
          sx={{ color: '#666' }}
        />
      )}
    </Box>
  );
}